// Occasions Store
import { upperFirst } from 'lodash'
import { objectTypeToType } from '@/helper'

const state = {
  anniversaries: [],
  birthdays: [],
  filterActive: false,
  filterOptions: [],
  filters: {},
  occasions: [],
  pending: false,
  pagination: {},
}

const getters = {}

const object_types = [
  'occasions.feed',
  'occasions.anniversaries',
  'occasions.birthdays',
]

const actions = {
  searchOccasions({ commit }, payload) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items
      .searchItems('occasions', payload)
      .then(({ data }) => {
        commit('SET_OCCASIONS', data)
        commit('SET_PENDING')
        resolve()
      })
    })
  },
  getOccasions({ commit }, page = 1) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items
      .getItems('occasions', { page })
      .then(({ data }) => {
        commit('SET_OCCASIONS', data)
        commit('SET_PENDING')
        resolve()
      })
    })
  },
  getOccasionFilters({ commit }) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items
      .getFilters('occasions')
      .then(({ data }) => {
        commit('SET_OCCASION_FILTERS', data)
        commit('SET_PENDING')
        resolve()
      })
    })
  },
  filterOccasions({ commit, state }, { page, query }) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items
        .filterItems('occasions', {
          query,
          ...state.filters,
          page,
        })
        .then(({ data }) => {
          commit('SET_OCCASIONS', data)
          commit('SET_FILTER_ACTIVE')
          commit('SET_PENDING')
          resolve()
        })
    })
  },
  setFilterActive({ commit }) {
    commit('SET_FILTER_ACTIVE')
  },
  resetFilter({ commit }) {
    commit('RESET_FILTER')
  },
  updateFilters({ commit }, data) {
    commit('UPDATE_FILTERS', data)
  },
  clearOccasions({ commit }) {
    commit('CLEAR_OCCASIONS')
  },
}

object_types.forEach(object_type => {
  actions['get' + upperFirst(objectTypeToType(object_type))] = function({ commit }, options = {}) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items
      .getItems(object_type, options)
      .then(({ data }) => {
        commit('SET_' + objectTypeToType(object_type).toUpperCase(), data)
        commit('SET_PENDING')
        resolve()
      })
    })
  }
})

const mutations = {
  SET_PENDING: state => {
    state.pending = !state.pending
  },
  SET_FILTER_ACTIVE: state => {
    state.filterActive = true
  },
  RESET_FILTER: state => {
    state.filterActive = false
    state.filters = {}
  },
  CLEAR_OCCASIONS(state) {
    state.filterActive = false
    state.filterOptions = []
    state.filters = {}
    state.pagination = {}
    state.occasions = []
  },
  SET_OCCASIONS: (state, { results, pagination }) => {
    state.occasions = results
    state.pagination = pagination
  },
  SET_OCCASION_FILTERS: (state, data) => {
    state.filterOptions = data
  },
  UPDATE_FILTERS: (state, data) => {
    state.filters = data
  },
}

object_types.forEach(object_type => {
  mutations['SET_' + objectTypeToType(object_type).toUpperCase()] = function(state, payload) {
    for (const prop in payload) {
      if (Object.prototype.hasOwnProperty.call(payload, prop)) {
        state[prop] = payload[prop]
      }
    }
  }
})

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
